export { AccessPointsUtil }

const GRADE_LEVEL = 'grade_level'
const APPROACHING = 'approaching'
const DEVELOPING = 'developing'

const AccessPointLabelsMap = Object.freeze({
  [GRADE_LEVEL]: 'Grade Level',
  [APPROACHING]: 'Approaching',
  [DEVELOPING]: 'Developing'
})

const AccessPointValues = Object.freeze({
  GRADE_LEVEL,
  APPROACHING,
  DEVELOPING
})
const AccessPointValuesList = [GRADE_LEVEL, APPROACHING, DEVELOPING]

const AccessPointsUtil = {
  valuesMap: AccessPointValues,
  orderedValues: AccessPointValuesList,
  labelsMap: AccessPointLabelsMap
}
